import { createRouter, createWebHashHistory } from 'vue-router'
import { isMobileDevice } from '@/utils/device.js'
import { h } from 'vue'

const routes = [
  // 后台首页----------
  {
    path: '/main',
    name: 'Main',
    component: () => import('@/views/layout/LayoutIndex'),
    meta: {
      title: '数据概况',
      icon: 'House',
      tabs: true,
      qx: 0
    },
    redirect: '/main/sysLog',
    children: [
      {
        path: 'sysLog',
        name: 'SysLog',
        meta: {
          title: '数据概况',
          icon: 'House',
          tabs: true,
        },
        component: () => import('@/views/MainView.vue')
      }
    ]
  },
  {
    path: '/DataScreen',
    name: 'DataScreen',
    component: () => import('../views/DataView.vue'),
    meta: {
      title: '数据大屏',
      icon: 'DataBoard',
      tabs: true,
      qx: 0
    },
    hidden: true,
  },
  
  {
    path: '/CommandMap',
    name: 'CommandMap',
    component: () => import('../views/CommandMap.vue'),
    meta: {
      title: '调度地图',
      icon: 'LocationInformation',
      tabs: true,
      qx: 0
    },
    hidden: true,
  },
  {
    path: '/VideoMonitor',
    name: 'VideoMonitor',
    component: () => import('../views/VideoMonitor.vue'),
    meta: {
      title: '视频汇聚平台',
      icon: 'VideoCamera',
      tabs: true,
      qx: 0
    },
    hidden: true,
  },
  {
    path: '/Navigation',
    name: 'home',
    component: () => import('../views/NavView.vue'),
    meta: {
      title: '指挥中心',
      icon: 'Position',
      tabs: true,
      qx: 0
    },
    hidden: true,
  },
  {
    path: '/DataManage',
    name: 'DataManage',
    component: () => import('@/views/layout/LayoutIndex'),
    // component: () => import('../components/MetricCardDemo.vue'),
    meta: {
      title: '数据管理',
      icon: 'MessageBox',
      tabs: true,
      qx: 0
    },
    children: [
      {
        path: 'CarList',
        name: 'CarList',
        meta: {
          title: '景区车辆实时定位数据',
          icon: 'OfficeBuilding',
          tabs: true,
        },
        component: () => import('../views/data/CarList.vue'),
      },
      {
        path: 'DahuaVideoChannelList',
        name: 'DahuaVideoChannelList',
        meta: {
          title: '景区视频通道数据',
          icon: 'VideoCamera',
          tabs: true,
        },
        component: () => import('../views/data/DahuaVideoChannelList.vue'),
      },
                  {
        path: 'YmyjdList',
        name: 'YmyjdList',
        meta: {
          title: '入驻酒店数据',
          icon: 'OfficeBuilding',
          tabs: true,
        },
        component: () => import('../views/data/YmyjdList.vue'),
      },  
       {
        path: 'YmyjdddList',
        name: 'YmyjdddList',
        meta: {
          title: '酒店订单数据',
          icon: 'Postcard',
          tabs: true,
        },
        component: () => import('../views/data/YmyjdddList.vue'),
      },
      
      {
        path: 'YmyspddList',
        name: 'YmyspddList',
        meta: {
          title: '商品订单数据',
          icon: 'Postcard',
          tabs: true,
        },
        component: () => import('../views/data/YmyspddList.vue'),
      },

            {
        path: 'YmyqyList',
        name: 'YmyqyList',
        meta: {
          title: '入驻企业数据',
          icon: 'School',
          tabs: true,
        },
        component: () => import('../views/data/YmyqyList.vue'),
      },
      {
        path: 'HzsgkList',
        name: 'HzsgkList',
        meta: {
          title: '合作社运营数据',
          icon: 'Suitcase',
          tabs: true,
        },
        component: () => import('../views/data/HzsgkList.vue'),
      },
      {
        path: 'YmygkList',
        name: 'YmygkList',
        meta: {
          title: '一码游运营数据',
          icon: 'Reading',
          tabs: true,
        },
        component: () => import('../views/data/YmygkList.vue'),
      },
            {
        path: 'YmyrsList',
        name: 'YmyrsList',
        meta: {
          title: '一码游游客量',
          icon: 'User',
          tabs: true,
        },
        component: () => import('../views/data/YmyrsList.vue'),
      },
      {
        path: 'IndustryList',
        name: 'IndustryList',
        meta: {
          title: '主要产业数据',
          icon: 'Coin',
          tabs: true,
        },
        component: () => import('../views/data/IndustryList.vue'),
      },
            {
        path: 'DzzhyjList',
        name: 'DzzhyjList',
        meta: {
          title: '地质灾害预警数据',
          icon: 'Coin',
          tabs: true,
        },
        component: () => import('../views/data/DzzhyjList.vue'),
      },
          {
        path: 'DzzhsbList',
        name: 'DzzhsbList',
        meta: {
          title: '地质监测设备数据',
          icon: 'Coin',
          tabs: true,
        },
        component: () => import('../views/data/DzzhsbList.vue'),
      },

      {
        path: 'DzzhcgqList',
        name: 'DzzhcgqList',
        meta: {
          title: '传感器设备数据',
          icon: 'Coin',
          tabs: true,
        },
        component: () => import('../views/data/DzzhcgqList.vue'),
      },

      {
        path: 'GuestCountList',
        name: 'GuestCountList',
        meta: {
          title: '游客数量数据',
          icon: 'User',
          tabs: true,
        },
        component: () => import('../views/data/GuestCountList.vue'),
      },
      {
        path: 'GuestAreaList',
        name: 'GuestAreaList',
        meta: {
          title: '游客区域数据',
          icon: 'LocationInformation',
          tabs: true,
        },
        component: () => import('../views/data/GuestAreaList.vue'),
      }, {
        path: 'GuestTicketList',
        name: 'GuestTicketList',
        meta: {
          title: '游客票务数据',
          icon: 'Ticket',
          tabs: true,
        },
        component: () => import('../views/data/GuestTicketList.vue'),
      },
      {
        path: 'TcmList',
        name: 'TcmList',
        meta: {
          title: '中药产业数据',
          icon: 'HotWater',
          tabs: true,
        },
        component: () => import('../views/data/TcmList.vue'),
      },
      {
        path: 'BeeList',
        name: 'BeeList',
        meta: {
          title: '蜜蜂产业数据',
          icon: 'Sugar',
          tabs: true,
        },
        component: () => import('../views/data/BeeList.vue'),
      },
      {
        path: 'DsList',
        name: 'DsList',
        meta: {
          title: '电商产业数据',
          icon: 'ShoppingTrolley',
          tabs: true,
        },
        component: () => import('../views/data/DsList.vue'),
      },
      {
        path: 'VeggieList',
        name: 'VeggieList',
        meta: {
          title: '蔬菜产业数据',
          icon: 'KnifeFork',
          tabs: true,
        },
        component: () => import('../views/data/VeggieList.vue'),
      },
      {
        path: 'BreedList',
        name: 'BreedList',
        meta: {
          title: '养殖产业数据',
          icon: 'Chicken',
          tabs: true,
        },
        component: () => import('../views/data/BreedList.vue'),
      },
      {
        path: 'WoodsList',
        name: 'WoodsList',
        meta: {
          title: '林果产业数据',
          icon: 'Pear',
          tabs: true,
        },
        component: () => import('../views/data/WoodsList.vue'),
      },
    ]

  },
  {
    path: '/DataAnalysis',
    name: 'DataAnalysis',
    component: () => import('../views/DataAnalysis.vue'),
    // component: () => import('../components/MetricCardDemo.vue'),
    meta: {
      title: '数据分析',
      icon: 'Histogram',
      tabs: true,
      qx: 0
    },
    hidden: true,
  },
  {
    path: '/SettingView',
    component: () => import('../views/SettingView.vue'),
    meta: {
      title: '系统配置',
      icon: 'Setting',
      qx: 0,
    },
    hidden: true,
    redirect: '/SettingView/settings',
    children: [
      {
        path: 'settings',
        name: 'SettingForm',
        meta: { title: '系统设置' },
        component: () => import('../views/SettingFormPanel.vue'),
      },
      {
        path: 'users/add',
        name: 'AddUser',
        hidden: true,
        meta: { title: '添加用户' },
        component: () => import('../views/user/AddUser.vue'),
      },
      {
        path: 'users/edit',
        name: 'EditUser',
        hidden: true,
        meta: { title: '编辑用户' },
        component: () => import('../views/user/EditUser.vue'),
      },
      {
        path: 'users',
        name: 'UserList',
        meta: { title: '用户管理' },
        component: () => import('../views/user/UserList.vue'),
      },
    ],
  },
  {
    path: '/SettingManage/SettingView',
    redirect: '/SettingView/settings',
  },
  {
    path: '/UserManage/UserList',
    redirect: '/SettingView/users',
  },
  {
    path: '/UserManage/AddUser',
    redirect: '/SettingView/users/add',
  },
  {
    path: '/UserManage/EditUser',
    redirect: (to) => ({
      path: '/SettingView/users/edit',
      query: to.query,
    }),
  },
  {
    path: '/LogManage',
    name: 'LogManage',
    component: () => import('@/views/layout/LayoutIndex'),
    // component: () => import('../components/MetricCardDemo.vue'),
    meta: {
      title: '系统日志',
      icon: 'Document',
      tabs: true,
      qx: 0
    },
    children: [
      {
        path: 'LogList',
        name: '系统日志',
        meta: {
          title: '系统日志',
          icon: 'Document',
          tabs: true,
        },
        component: () => import('../views/data/LogList.vue'),
      },
    ]
  }, 
  {
    path: '/login-mobile-hint',
    name: 'LoginMobileHint',
    meta: { title: '请使用电脑端访问' },
    hidden: true,
    component: () => import('../views/LoginMobileHint.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    beforeEnter(to, from, next) {
      if (isMobileDevice()) {
        return next({ name: 'LoginMobileHint', replace: true })
      }
      next()
    },
  },
  {
    path: '/',
    name: 'Login2',
    redirect: '/login',
  }, {
    path: '/DataTest',
    name: 'DataTest',

    component: () => import('../views/DataTest.vue')
  }, {
    path: '/DataAnalysis',
    name: 'DataAnalysis',

    component: () => import('../views/DataAnalysis.vue')
  }, {
    path: '/IndexNav',
    name: 'IndexNav',
  meta: {
      title: '返回导航',
      icon: 'WindPower',
      tabs: true,
      qx: 0
    }, 
    component: () => import('../views/IndexNav.vue')
  }, {
    path: '/VrSystem',
    name: 'VrSystem',
    meta: { title: 'VR系统' },
    hidden: true,
    component: () => import('../views/ModulePlaceholder.vue')
  }, {
    path: '/WechatMiniProgram',
    name: 'WechatMiniProgram',
    meta: { title: '微信小程序' },
    hidden: true,
    component: () => import('../views/ModulePlaceholder.vue')
  }, {
    path: '/WxCloud',
    name: 'WxCloudHub',
    meta: {
      title: '小程序云开发管理',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudHub.vue'),
  }, {
    path: '/WxCloud/debug',
    name: 'WxCloud',
    meta: {
      title: '云开发接口调试',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudView.vue'),
  }, {
    path: '/WxCloud/users',
    name: 'WxCloudUserList',
    meta: {
      title: '云开发用户列表',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudUserList.vue'),
  }, {
    path: '/WxCloud/config',
    name: 'WxCloudConfigList',
    meta: {
      title: '云开发配置管理',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudConfigList.vue'),
  }, {
    path: '/WxCloud/logs',
    name: 'WxCloudLogsList',
    meta: {
      title: '云开发日志',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudLogsList.vue'),
  }, {
    path: '/WxCloud/position',
    name: 'WxCloudPositionList',
    meta: {
      title: '云开发位置',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudPositionList.vue'),
  }, {
    path: '/WxCloud/hot-position',
    name: 'WxCloudHotPositionList',
    meta: {
      title: '云开发调度点管理',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudHotPositionList.vue'),
  }, {
    path: '/WxCloud/traffic-monitor',
    name: 'WxCloudTrafficMonitorList',
    meta: {
      title: '云开发路况监测点',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudTrafficMonitorList.vue'),
  }, {
    path: '/WxCloud/guestbook',
    name: 'WxCloudGuestbookList',
    meta: {
      title: '云开发意见反馈',
      tabs: true,
      qx: 0,
    },
        hidden: true,
    component: () => import('../views/wxcloud/WxCloudGuestbookList.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
